export enum ModularHouseOfferConstructionTech {
    WOODEN_ELEMENTS = 1,
    CONCRETE_ELEMENTS = 2,
    EXPANDED_CLAY_ELEMENTS = 3,
    WOODEN_FRAME = 4,
    STEEL_FRAME = 5,
    PREFABRICATED_MODULES = 6
}
export enum ModularHouseOfferConstructionTech {
    WOODEN_ELEMENTS = 1,
    CONCRETE_ELEMENTS = 2,
    EXPANDED_CLAY_ELEMENTS = 3,
    WOODEN_FRAME = 4,
    STEEL_FRAME = 5,
    PREFABRICATED_MODULES = 6
}
